import './PrivacyPolicy.css';
import {Helmet} from "react-helmet-async";

export default function PrivacyPolicy() {
    return <div id='privacy-policy'>
        <Helmet>
            <title>Polityka prywatności | Lumestore</title>
            <meta name="description" content="Polityka prywatności Lumestore – informacje o przetwarzaniu danych." />
            <link rel="canonical" href="https://lumestore.pl/polityka" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Polityka prywatności | Lumestore" />
            <meta property="og:description" content="Polityka prywatności Lumestore – informacje o przetwarzaniu danych." />
            <meta property="og:url" content="https://lumestore.pl/polityka" />
        </Helmet>
        <h1>Polityka prywatności sklepu internetowego Lume Store</h1>

        <h2>§ 1. Administrator danych osobowych</h2>
        <p>
            Administratorem danych osobowych jest <strong>LUMESTORE</strong>, z siedzibą przy:
            ul. Pograniczna 13, 32-087 Garlica Murowana, NIP: 5130301837,
            e-mail: kontakt@lumestore.pl
        </p>

        <h2>§ 2. Zakres zbieranych danych</h2>
        <ol>
            <li>imię i nazwisko,</li>
            <li>adres do wysyłki,</li>
            <li>adres e-mail,</li>
            <li>numer telefonu,</li>
            <li>dane do faktury (NIP – w przypadku przedsiębiorców),</li>
            <li>dane techniczne związane z korzystaniem ze strony (np. adres IP, pliki cookies).</li>
        </ol>

        <h2>§ 3. Cel i podstawa prawna przetwarzania danych</h2>
        <p>Dane osobowe przetwarzane są w następujących celach:</p>
        <ol>
            <li>realizacja zamówień RODO art. 6 ust. 1 lit. b),</li>
            <li>obsługa reklamacji i odstąpienia od umowy (RODO art. 6 ust. 1 lit. c),</li>
            <li>prowadzenie konta użytkownika (RODO art. 6 ust. 1 lit. b),</li>
            <li>kontakt e-mailowy i telefoniczny w sprawie zamówienia (RODO art. 6 ust. 1 lit. f),</li>
            <li>działania marketingowe, np. newsletter (RODO art. 6 ust. 1 lit. a – zgoda),</li>
            <li>cele podatkowe i księgowe (RODO art. 6 ust. 1 lit. c).</li>
        </ol>

        <h2>§ 4. Przekazywanie danych</h2>
        <p>Dane osobowe mogą być przekazywane podmiotom współpracującym z Administratorem przy realizacji zamówień, w szczególności:</p>
        <ol>
            <li>firmom kurierskim i pocztowym,</li>
            <li>operatorom płatności (np. Tpay, banki, Przelewy24),</li>
            <li>firmie księgowej,</li>
            <li>dostawcom usług IT (hosting, oprogramowanie sklepu).</li>
        </ol>

        <h2>§ 5. Czas przechowywania danych</h2>
        <ol>
            <li>dane związane z realizacją umowy – przez okres obowiązywania umowy i do czasu przedawnienia roszczeń (zwykle 6 lat),</li>
            <li>dane księgowe – zgodnie z przepisami podatkowymi (min. 5 lat),</li>
            <li>dane marketingowe – do czasu wycofania zgody.</li>
        </ol>

        <h2>§ 6. Prawa użytkowników</h2>
        <p>Każdy użytkownik ma prawo do:</p>
        <ol>
            <li>dostępu do danych,</li>
            <li>sprostowania danych,</li>
            <li>usunięcia danych,</li>
            <li>ograniczenia przetwarzania,</li>
            <li>przenoszenia danych,</li>
            <li>sprzeciwu wobec przetwarzania,</li>
            <li>wycofania zgody w dowolnym momencie.</li>
        </ol>
        <p>
            Wniosek w sprawie danych osobowych można przesłać na adres:
            kontakt@lumestore.pl
        </p>

        <h2>§ 7. Prawo do skargi</h2>
        <p>
            Osoba, której dane dotyczą, ma prawo złożyć skargę do Prezesa Urzędu Ochrony Danych Osobowych (UODO).
        </p>

        <h2>§ 8. Bezpieczeństwo danych</h2>
        <p>
            Administrator stosuje środki techniczne i organizacyjne zapewniające ochronę danych przed ich utratą,
            zniszczeniem, nieuprawnionym dostępem lub ujawnieniem.
        </p>


    </div>;
}
